export const ROLES = {
	MASTER: 'master',
	ADMIN: 'admin',
	SHOP: 'shop',
};
